<template>
  <div class="add_pricing_modal">
    <widgetModal :title="'EDIT YOUR WEBSITE THEME'" btnlefttext="Cancel" btnrighttext="Save"
      :leftloading="submitingLoading" :rightloading="false" :footerhidden="false" @onLeftClick="onComfirm"
      @onRightClick="onClose">
      <div class="widget-modal-body-noscoll">
        <b-field label="Website Logo" style="width: 100%">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL" :uploadurl="$store.state.BASE_URL + 'upload'"
            name="main-image" :value="form.webLogo" @onFileSelected="(file) => {
              form.webLogo = file;
            }">
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>
        <div class="row">
          <div class="v-spacer"></div>
          <b-field label="Website Primary Color" style="width: 100%">
            <b-colorpicker v-model="primaryColor" :alpha="alpha" :color-formatter="formatter" />
          </b-field>
          <div class="v-spacer"></div>
          <b-field label="Website Secondary Color" style="width: 100%">
            <b-colorpicker v-model="secondaryColor" :alpha="alpha" :color-formatter="formatter" />
          </b-field>
        </div>

        <b-field label="Favicon icon" style="width: 100%">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL" :uploadurl="$store.state.BASE_URL + 'upload'"
            name="main-image" :value="form.webFavicon" @onFileSelected="(file) => {
              form.webFavicon = file;
            }">
            <div class="image-upload-widget">Choose Icon to upload</div>
          </upload-trigger>
        </b-field>
        <div class="row">
          <b-field label="Title" style="width: 100%">
            <b-input v-model="form.title"></b-input>
          </b-field>
        </div>
        <b-field label="Description">
          <b-input v-model="form.description" maxlength="500" type="textarea"></b-input>
        </b-field>
        <b-field label="Keywords">
          <b-taginput v-model="tags" ellipsis icon="label" placeholder="Add a keyword"
            aria-close-label="Delete this keyword">
          </b-taginput>
        </b-field>
      </div>
    </widgetModal>
  </div>
</template>

<script>
import Color from "buefy/src/utils/color.js";
export default {
  name: "edit_website_theme",
  props: {
    current: {
      type: Object,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      alpha: false,
      submitingLoading: false,
      resetingLoading: false,
      primaryColor: Color.parse('#000000'),
      secondaryColor: Color.parse('#000000'),
      form: {
        webLogo: '',
        webFavicon: '',
        primaryColor: '',
        secondaryColor: '',
        title: '',
        description: '',
        keywords: []
      },
      tags: [],
    };
  },
  mounted() {
    let vm = this;
    if (vm.current) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  methods: {
    formatter(color) {
      return color.toString(this.alpha ? 'rgba' : 'rgb')
    },
    resetFormFields() {
      let vm = this;
      vm.form = {
        webLogo: '',
        webFavicon: '',
        primaryColor: Color.parse('#000000'),
        secondaryColor: Color.parse('#000000'),
        title: '',
        description: '',
        keywords: []
      };
    },
    setFormFields() {
      let vm = this;
      vm.form = {
        webLogo: vm.current.webLogo,
        webFavicon: vm.current.webFavicon,
        primaryColor: vm.current.primaryColor,
        secondaryColor: vm.current.secondaryColor,
        title: vm.current.title,
        description: vm.current.description,
        keywords: vm.current.keywords
      };
      vm.tags = JSON.parse(vm.current.keywords);
      vm.primaryColor = Color.parse(JSON.parse(vm.current.primaryColor))
      vm.secondaryColor = Color.parse(JSON.parse(vm.current.secondaryColor))
    },
    onComfirm() {
      let vm = this;
      vm.form.primaryColor = JSON.stringify(vm.primaryColor);
      vm.form.secondaryColor = JSON.stringify(vm.secondaryColor);
      vm.form.keywords = JSON.stringify(vm.tags);
      // Start validate
      const rules = {
        webLogo: {
          run: (value) => {
            if (!value) {
              return "Please select website logo";
            }
            return false;
          },
        },
        webFavicon: {
          run: (value) => {
            if (!value) {
              return "Please select website favicon";
            }
            return false;
          },
        },
        title: {
          run: (value) => {
            if (!value) {
              return "Please enter website title";
            }
            return false;
          },
        },
        description: {
          run: (value) => {
            if (!value) {
              return "Please enter website description";
            }
            return false;
          },
        },

      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submitingLoading = true;
        vm.$store
          .dispatch("ADMIN_USER_SAVE_WEBSITE_THEME", vm.form)
          .then((response) => {
            vm.submitingLoading = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Message",
              text: response.data.message,
            });
            vm.$emit("success", vm.form);
          })
          .catch(({ response }) => {
            vm.submitingLoading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "Message",
              text: response.data.message,
            });
          });
      }
    },
    onClose() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>